module.exports = __webpack_public_path__ + "static/media/Huberdeau_Logo.d9f6cce7.jpg";